// extracted by mini-css-extract-plugin
export default {"wrapper":"styles__wrapper___bRBIf","innerWrapper":"styles__innerWrapper___ahnSo","fullWidth":"styles__fullWidth___J3Smn"};